import React from 'react';

export default class FieldComponent extends React.Component {
    render() {
        return (
            <div className="field">
                <label className="label">{this.props.label}</label>
                <div className={`control${this.props.icon ? ' has-icons-left' : ""} has-icons-right`}>
                    {this.props.type == "textarea" ?
                    <textarea value={this.props.value} disabled={this.props.disabled}
                        rows={this.props.rows} style={{resize: "none"}}
                        onChange={this.props.onInputChange} name={this.props.name}
                        className="textarea">
                    </textarea> :
                    <input value={this.props.value} disabled={this.props.disabled}
                        onChange={this.props.onInputChange} name={this.props.name} maxLength={this.props.maxLength}
                        className="input" type={this.props.type ? this.props.type : "text"}/>}
                    {this.props.icon &&
                    <span className="icon is-small is-left" style={{zIndex: 0}}>
                        <i className={`fas fa-${this.props.icon}`}></i>
                    </span>}
                    {this.props.error ? <p className="help is-danger">{this.props.error}</p> :
                        <p><br /></p>}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/field/index.js